/*
  APMX — Fecha de recolección en sucursal (reglas de Alejandro, 9-oct-2026).

  Regla: se recoge a las 9:30 de un día de recolección (lunes a viernes, sin
  festivos), el primero en que ya pasaron al menos 24 horas "efectivas" desde la
  compra. Para esas 24 h NO cuentan el sábado en la tarde (desde sabadoCorte),
  el domingo ni los festivos.
  Ej.: compra lunes 8:00 → martes 9:30 · lunes 10:14 → miércoles 9:30 ·
       viernes 12:00 → lunes 9:30 (sólo cuenta el sábado hasta las 14:00).

  Todo el cálculo se hace con la hora de America/Mexico_City (Intl), no con la
  del reloj del visitante.

  Pinta los contenedores [data-apx-recoleccion] (snippet apx-recoleccion.liquid),
  que vienen ocultos: si este script no corre, no se ve nada.
*/
(function (root) {
  'use strict';

  /* ===================== CONFIGURACIÓN (editar aquí) ===================== */
  var CONFIG = {
    zona: 'America/Mexico_City',
    sucursal: 'Guadalajara',
    minimoHoras: 24,      // horas efectivas mínimas entre la compra y la recolección
    horaRecoleccion: 9.5, // 9:30
    sabadoCorte: 14,      // desde esta hora el sábado ya no cuenta para las 24 h
    diasRecoleccion: [1, 2, 3, 4, 5], // 0 = domingo ... 6 = sábado

    /* Días festivos oficiales (LFT art. 74) que NO son hábiles. Formato AAAA-MM-DD.
       Agregar aquí los de 2028 en adelante, o cierres especiales de la sucursal. */
    festivos: [
      // 2026
      '2026-01-01', // Año Nuevo
      '2026-02-02', // Constitución (primer lunes de febrero)
      '2026-03-16', // Natalicio de Benito Juárez (tercer lunes de marzo)
      '2026-05-01', // Día del Trabajo
      '2026-09-16', // Independencia
      '2026-11-16', // Revolución (tercer lunes de noviembre)
      '2026-12-25', // Navidad
      // 2027
      '2027-01-01',
      '2027-02-01',
      '2027-03-15',
      '2027-05-01',
      '2027-09-16',
      '2027-11-15',
      '2027-12-25'
    ]
  };
  /* ======================================================================= */

  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
    'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var HORA_MS = 3600000;
  var MEDIA_MS = HORA_MS / 2;

  /* "Hora de pared" de la CDMX para un instante, codificada como si fuera UTC.
     Así se puede sumar/redondear sin que influya la zona del visitante. */
  var fmt = null;
  function paredMx(ms) {
    if (!fmt) {
      fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: CONFIG.zona, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    }
    var p = {};
    fmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  }

  function claveDia(d) {
    return d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2);
  }

  function esFestivo(d) { return CONFIG.festivos.indexOf(claveDia(d)) !== -1; }

  function esHabil(d) {
    return CONFIG.diasRecoleccion.indexOf(d.getUTCDay()) !== -1 && !esFestivo(d);
  }

  /* ¿Cuenta este instante (hora de pared) para las 24 h? */
  function cuenta(d) {
    var dia = d.getUTCDay();
    if (dia === 0 || esFestivo(d)) return false;
    if (dia === 6 && d.getUTCHours() + d.getUTCMinutes() / 60 >= CONFIG.sabadoCorte) return false;
    return true;
  }

  var PASO = HORA_MS / 4; // 15 min
  function horasEfectivas(desde, hasta) {
    var n = 0;
    for (var t = desde; t < hasta; t += PASO) if (cuenta(new Date(t))) n++;
    return n * PASO / HORA_MS;
  }

  /* Devuelve la fecha de recolección (Date en "hora de pared" CDMX vía getUTC*). */
  function calcular(ahoraMs) {
    var t0 = paredMx(ahoraMs == null ? Date.now() : ahoraMs);
    var hoy = new Date(t0);
    for (var k = 1; k <= 30; k++) {
      var d = new Date(Date.UTC(hoy.getUTCFullYear(), hoy.getUTCMonth(), hoy.getUTCDate() + k, 0, CONFIG.horaRecoleccion * 60));
      if (esHabil(d) && horasEfectivas(t0, d.getTime()) >= CONFIG.minimoHoras) return d;
    }
    return d;
  }

  /* "jueves 15 de octubre, 9:00 h" */
  function formatear(d) {
    return DIAS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' de ' + MESES[d.getUTCMonth()] +
      ', ' + d.getUTCHours() + ':' + ('0' + d.getUTCMinutes()).slice(-2) + ' h';
  }

  function texto(ahoraMs) {
    return 'Recoge en sucursal ' + CONFIG.sucursal + ' a partir del ' + formatear(calcular(ahoraMs));
  }

  var api = { CONFIG: CONFIG, calcular: calcular, formatear: formatear, texto: texto, esHabil: esHabil };

  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (root.apxRecoleccion) return; // el snippet puede cargar el script más de una vez
  root.apxRecoleccion = api;

  function pintar(scope) {
    var nodos = (scope || document).querySelectorAll('[data-apx-recoleccion]');
    if (!nodos.length) return;
    var d, frase;
    try { d = calcular(); frase = formatear(d); } catch (e) { return; }
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      var f = el.querySelector('[data-apx-recoleccion-fecha]');
      if (!f) continue;
      f.textContent = '';
      f.appendChild(document.createTextNode('Recoge en sucursal ' + CONFIG.sucursal + ' a partir del '));
      var b = document.createElement('strong');
      b.textContent = frase;
      f.appendChild(b);
      el.hidden = false;
    }
  }

  function iniciar() {
    pintar();
    // el carrito (página y cajón) se vuelve a dibujar al cambiar cantidades
    if (root.MutationObserver) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () {
          pendiente = false;
          if (document.querySelector('[data-apx-recoleccion][hidden]')) pintar();
        }, 50);
      }).observe(document.body, { childList: true, subtree: true });
    }
    // si la pestaña estuvo abierta un rato, recalcula al volver
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') pintar();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})(typeof window !== 'undefined' ? window : this);
